/* TypeScript file generated from Utils__Time.resi by genType. */

/* eslint-disable */
/* tslint:disable */

import * as Utils__TimeJS from './Utils__Time.bs.js';

export const minuteInMs: number = Utils__TimeJS.minuteInMs as any;
